exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_playlists_sk3HtFphgHRjRWxc4hyi_ {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_1bwrSHHX5-tGbT22blCI-W {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_3I_gx6NKTiKOT0TyL9022y {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_2Zpz2ok2m7z2HazwWmRKFy {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_playlists": "IA_playlists_sk3HtFphgHRjRWxc4hyi_",
	"IA_filters": "IA_filters_1bwrSHHX5-tGbT22blCI-W",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_3I_gx6NKTiKOT0TyL9022y",
	"IA_paginationPageCount": "IA_paginationPageCount_2Zpz2ok2m7z2HazwWmRKFy"
};